export default "__VITE_ASSET__6257e166__"